import React, { Component } from "react";
import {
  Accordion,
  Button,
  Container,
  Grid,
  Message,
  Popup,
  Segment,
  Tab,
  Form
} from "semantic-ui-react";
import { ChromePicker } from "react-color";
import update from 'immutability-helper';
import request from "../../utils/request";
import { AppContext } from "../../utils/context";
import { apiUrl, invertColor } from "../../utils/constants";

import UploadImageForm from "../../components/content/UploadImageForm";
import WebSalesTemplate from "../../components/content/WebSalesTemplate";
import ModalUpload from '../../components/forms/upload/ModalUpload'

const defaultEvent = {
  "id": 1,
  "title": "DEMO RAFFLE WEEK 1",
  "date": "2020-05-19",
  "start_at": "2020-04-01 10:30:00",
  "end_at": "2020-05-19 08:10:00",
  "prices": { "5": 10, "20": 20, "80": 40, "250": 100 },
  "pricing": "default",
  "jackpot": 91944,
  "prize": 0,
  "draws": [
    { "title": "Weekly Prize", "number": null, "jackpot": "91944.00", "prize": "0.00", "is_grand": 1, "draw_at": null, "first_name": null, "last_name": null, "card": false, "winning_card": false }
  ],
  "nonprofit": {
    "id": 1, "name": "DEMO ORGANIZATION",
    "pri_email": null,
    "pri_phone_number": null
  }
  , "game": {
    "id": 3,
    "title": "Catch the Ace",
    "label": null,
    "description": "The raffle sales are divided into three parts. Typically the organizers keep 50%, the winner of the weekly lottery takes 20%, and the remaining 30% goes into the jackpot.",
    "created_at": "2019-08-15 13:16:23",
    "updated_at": "2019-08-28 11:55:04",
    "deleted_at": null
  },
  "beneficiaries": [],
  "beneficiaryenabled": 1,
  "is_active": true,
  "cards": [{ "envelope": 1, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 2, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 3, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 4, "drawn": true, "rank": "A", "suit": "D" }, { "envelope": 5, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 6, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 7, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 8, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 9, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 10, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 11, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 12, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 13, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 14, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 15, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 16, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 17, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 18, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 19, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 20, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 21, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 22, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 23, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 24, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 25, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 26, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 27, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 28, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 29, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 30, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 31, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 32, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 33, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 34, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 35, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 36, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 37, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 38, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 39, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 40, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 41, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 42, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 43, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 44, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 45, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 46, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 47, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 48, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 49, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 50, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 51, "drawn": true, "rank": "3", "suit": "S" }, { "envelope": 52, "drawn": true, "rank": "J", "suit": "S" }]
}

class WebSales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      needsSaving: false,
      isSaving: false,
      needsUploading: false,
      isLoading: true,
      activeIndex: 0,
      xhrResponse: {
        success: null,
        message: ""
      },
      files: [],
      colorPallete: {
        "--color-black": "unset",
        "--color-white": "unset",
        "--color-grey-darkest": "unset",
        "--color-grey-darker": "unset",
        "--color-grey-dark": "unset",
        "--color-grey": "unset",
        "--color-grey-light": "unset",
        "--color-grey-lighter": "unset",
        "--color-grey-lightest": "unset",
        "--color-primary-contrast": "unset",
        "--color-primary-darkest": "unset",
        "--color-primary-darker": "unset",
        "--color-primary-dark": "unset",
        "--color-primary": "unset",
        "--color-primary-light": "unset",
        "--color-primary-lighter": "unset",
        "--color-primary-lightest": "unset",
        "--color-secondary-contrast": "unset",
        "--color-secondary-darkest": "unset",
        "--color-secondary-darker": "unset",
        "--color-secondary-dark": "unset",
        "--color-secondary": "unset",
        "--color-secondary-light": "unset",
        "--color-secondary-lighter": "unset",
        "--color-secondary-lightest": "unset",
        "--color-accent-contrast": "unset",
        "--color-accent-darkest": "unset",
        "--color-accent-darker": "unset",
        "--color-accent-dark": "unset",
        "--color-accent": "unset",
        "--color-accent-light": "unset",
        "--color-accent-lighter": "unset",
        "--color-accent-lightest": "unset",
        "--color-danger-darkest": "unset",
        "--color-danger-darker": "unset",
        "--color-danger-dark": "unset",
        "--color-danger": "unset",
        "--color-danger-light": "unset",
        "--color-danger-lighter": "unset",
        "--color-danger-lightest": "unset",
        "--color-warning-darkest": "unset",
        "--color-warning-darker": "unset",
        "--color-warning-dark": "unset",
        "--color-warning": "unset",
        "--color-warning-light": "unset",
        "--color-warning-lighter": "unset",
        "--color-warning-lightest": "unset",
        "--color-success-darkest": "unset",
        "--color-success-darker": "unset",
        "--color-success-dark": "unset",
        "--color-success": "unset",
        "--color-success-light": "unset",
        "--color-success-lighter": "unset",
        "--color-success-lightest": "unset",
        "--color-info-darkest": "unset",
        "--color-info-darker": "unset",
        "--color-info-dark": "unset",
        "--color-info": "unset",
        "--color-info-light": "unset",
        "--color-info-lighter": "unset",
        "--color-info-lightest": "unset",
      }
    };
    this.renderThemesTab = this.renderThemesTab.bind(this);
    this.renderColorsTab = this.renderColorsTab.bind(this);
    this.renderAssetsTab = this.renderAssetsTab.bind(this);
    this.renderStepsTab = this.renderStepsTab.bind(this);
    this.renderSettingsTab = this.renderSettingsTab.bind(this);
    this.renderSocialTab = this.renderSocialTab.bind(this);
    this.getUploadParams = this.getUploadParams.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount = async () => {
    //get settings for game 3 cta
    let resp = await request.get(this, "api:/settings?game_id=3");
    let settingsData = resp.settings["web"];
    let mapping = {};
    settingsData.map((value) => {
      return mapping[value.varname] = value.value;
    });
    //get settings for game 0
    resp = await request.get(this, "api:/settings?game_id=0");
    settingsData = resp.settings["web"];
    settingsData.map((value) => {
      return mapping[value.varname] = value.value;
    });
    let language = await request.get(this, "api:/web/language", {});
    let event = await request.get(this, "api:/web/event", {})
    if (event && event.length > 0) {
      event = await request.get(this, `api:/web/event/${event[0].id}`, {})
    } else {
      event = defaultEvent;
    }
    resp = await request.get(this, "api:/content/e-commerce", {});
    const cp = Object.assign({}, this.state.colorPallete);
    cp["--color-primary"] = resp && resp.theme && resp.theme.primaryContrast ? resp.theme.primaryColor : this.state.primaryColor;
    cp["--color-primary-contrast"] = resp && resp.theme && resp.theme.primaryContrast ? resp.theme.primaryContrast : this.state.primaryContrast
    cp["--color-secondary"] = resp && resp.theme && resp.theme.secondaryColor ? resp.theme.secondaryColor : this.state.secondaryColor;
    cp["--color-secondary-contrast"] = resp && resp.theme && resp.theme.secondaryContrast ? resp.theme.secondaryContrast : this.state.secondaryContrast
    cp["--color-accent"] = resp && resp.theme && resp.theme.accentColor ? resp.theme.accentColor : this.state.accentColor;
    cp["--color-accent-contrast"] = resp && resp.theme && resp.theme.accentContrast ? resp.theme.accentContrast : this.state.accentContrast
    this.setState({
      settings: mapping,
      language: language,
      event: event,
      colorPallete: cp,
      isLoading: false,
    });
  };
  handleAccordion = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handlePrimaryColor = (color, event) => {
    const cp = Object.assign({}, this.state.colorPallete);
    cp["--color-primary"] = color.hex;
    cp["--color-primary-contrast"] = invertColor(color.hex, 1)
    this.setState({ colorPallete: cp, needsSaving: true });
  };
  handleSecondaryColor = (color, event) => {
    const cp = Object.assign({}, this.state.colorPallete);
    cp["--color-secondary"] = color.hex;
    cp["--color-secondary-contrast"] = invertColor(color.hex, 1)
    this.setState({ colorPallete: cp, needsSaving: true });
  };
  handleAccentColor = (color, event) => {
    const cp = Object.assign({}, this.state.colorPallete);
    cp["--color-accent"] = color.hex;
    cp["--color-accent-contrast"] = invertColor(color.hex, 1)
    this.setState({ colorPallete: cp, needsSaving: true });
  };
  handleSave = async () => {

    const { needsUploading } = this.state;
    this.setState({
      isSaving: true
    });
    if (!needsUploading) {
      this.finishSave()
    }
  }
  finishSave = async () => {

    const { colorPallete } = this.state;
    let payload = {
      primaryColor: colorPallete["--color-primary"],
      secondaryColor: colorPallete["--color-secondary"],
      accentColor: colorPallete["--color-accent"],
      primaryContrast: colorPallete["--color-primary-contrast"],
      secondaryContrast: colorPallete["--color-secondary-contrast"],
      accentContrast: colorPallete["--color-accent-contrast"],
    };
    let resp = await request.post(this, "api:/settings", this.state.settings)
    if (!resp.success && resp.success !== null) {
      this.setState(
        {
          xhrResponse: resp,
          isLoading: false,
          isSaving: false,
        }
      );
      return;
    }
    resp = await request.put(this, "api:/content/e-commerce/theme", payload)
    if (!resp.success && resp.success !== null) {
      this.setState(
        {
          xhrResponse: resp,
          isLoading: false,
          isSaving: false,
        }
      );
      return;
    }
    this.setState(
      {
        xhrResponse: resp,
        isLoading: false,
        isSaving: false,
        needsSaving: false,
        needsUploading: false,
        files: []
      }
    );
  }
  handleDrop = (i, file) => {
    if (!file) {
      return;
    }
    const { settings } = this.state
    const img = URL.createObjectURL(file);
    settings[i] = img;
    file.location = i;
    this.setState(prevState => ({
      files: update(prevState.files, { $push: [file] }),
      needsUploading: true,
      settings: settings,
      needsSaving: true
    }));
  };
  deleteElementLogo = (i) => {
    const { settings } = this.state;
    settings[i] = "";
    let newFiles = this.state.files.filter(function (el) {
      return el['location'] !== i && el != null;
    });
    this.setState({ settings: settings, files: newFiles, needsSaving: true });
  }
  renderThemesTab = () => {
    const { colorPallete, settings } = this.state;
    return (
      <Tab.Pane>
        <div>
          <Segment basic>
            Primary{" "}
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Background"
                  style={{
                    backgroundColor: colorPallete["--color-primary"],
                    color: colorPallete["--color-primary-contrast"],
                  }}
                />
              }
              content={
                <ChromePicker
                  color={colorPallete["--color-primary"]}
                  onChangeComplete={this.handlePrimaryColor}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
          <Segment basic>
            Secondary{" "}
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Background"
                  style={{
                    backgroundColor: colorPallete["--color-secondary"],
                    color: colorPallete["--color-secondary-contrast"]
                  }}
                />
              }
              content={
                <ChromePicker
                  color={colorPallete["--color-secondary"]}
                  onChangeComplete={this.handleSecondaryColor}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
          <Segment basic>
            Accent{" "}
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Background"
                  style={{
                    backgroundColor: colorPallete["--color-accent"],
                    color: colorPallete["--color-accent-contrast"]
                  }}
                />
              }
              content={
                <ChromePicker
                  color={colorPallete["--color-accent"]}
                  onChangeComplete={this.handleAccentColor}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
        </div>
      </Tab.Pane>
    )
  }

  renderColorsTab = () => {
    const { settings } = this.state;
    return (
      <Tab.Pane>
        <div>
          <Segment basic>
            Hero Background Color
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Color"
                  style={{
                    backgroundColor: settings.hero_background_color,
                    color: invertColor(settings.hero_background_color, 1)
                  }}
                />
              }
              content={
                <ChromePicker
                  color={settings.hero_background_color}
                  onChangeComplete={(color) => this.handleSettingsChange(null, { name: "hero_background_color", value: color.hex })}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
          <Segment basic>
            Hero Text Color
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Color"
                  style={{
                    backgroundColor: settings.hero_text_color,
                    color: invertColor(settings.hero_text_color, 1)
                  }}
                />
              }
              content={
                <ChromePicker
                  color={settings.hero_text_color}
                  onChangeComplete={(color) => this.handleSettingsChange(null, { name: "hero_text_color", value: color.hex })}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
          <Segment basic>
            Hero Draw Title Color
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Color"
                  style={{
                    backgroundColor: settings.hero_draw_title_color,
                    color: invertColor(settings.hero_draw_title_color, 1)
                  }}
                />
              }
              content={
                <ChromePicker
                  color={settings.hero_draw_title_color}
                  onChangeComplete={(color) => this.handleSettingsChange(null, { name: "hero_draw_title_color", value: color.hex })}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
          <Segment basic>
            Progressive Jackpot Title Color
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Color"
                  style={{
                    backgroundColor: settings.hero_progressive_title_color,
                    color: invertColor(settings.hero_progressive_title_color, 1)
                  }}
                />
              }
              content={
                <ChromePicker
                  color={settings.hero_progressive_title_color}
                  onChangeComplete={(color) => this.handleSettingsChange(null, { name: "hero_progressive_title_color", value: color.hex })}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
          <Segment basic>
            Weekly Jackpot Title Color
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Color"
                  style={{
                    backgroundColor: settings.hero_weekly_title_color,
                    color: invertColor(settings.hero_weekly_title_color, 1)
                  }}
                />
              }
              content={
                <ChromePicker
                  color={settings.hero_weekly_title_color}
                  onChangeComplete={(color) => this.handleSettingsChange(null, { name: "hero_weekly_title_color", value: color.hex })}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
          <Segment basic>
            Envelope Number Color
            <Popup
              basic
              style={{ padding: 0, boxShadow: 0 }}
              trigger={
                <Button
                  circular
                  floated="right"
                  icon="paint brush"
                  content="Color"
                  style={{
                    backgroundColor: settings.envelope_number_color,
                    color: invertColor(settings.envelope_number_color, 1)
                  }}
                />
              }
              content={
                <ChromePicker
                  color={settings.envelope_number_color}
                  onChangeComplete={(color) => this.handleSettingsChange(null, { name: "envelope_number_color", value: color.hex })}
                />
              }
              on="click"
              position="bottom left"
            />
          </Segment>
        </div>
      </Tab.Pane>
    )
  }

  renderAssetsTab = () => {
    const { settings } = this.state;
    const panels = [];

    panels.push({
      key: 'panel-1',
      title: {
        content: "Header Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.header_logo}
            id="header_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-2',
      title: {
        content: "Primary Left Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.primary_left_logo}
            id="primary_left_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-3',
      title: {
        content: "Primary Right Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.primary_right_logo}
            id="primary_right_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-4',
      title: {
        content: "Email Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.email}
            id="email"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-5',
      title: {
        content: "Background Video",
      },
      content: {
        content: (
          <UploadImageForm
            videoFile={settings.hero_video}
            id="hero_video"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="video/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-6',
      title: {
        content: "Background Image",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.hero_image}
            id="hero_image"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-7',
      title: {
        content: "Checkout Background Image",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.checkout_background_image}
            id="checkout_background_image"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-8',
      title: {
        content: "Envelope Background Image",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.envelope_background_image}
            id="envelope_background_image"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-9',
      title: {
        content: "Social Share Image",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.social_og_image}
            id="social_og_image"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    return (
      <Tab.Pane>
        <Accordion fluid styled panels={panels} />
      </Tab.Pane>
    )
  }

  renderStepsTab = () => {
    const { settings } = this.state
    const panels = [];
    panels.push({
      key: 'panel-1',
      title: {
        content: "Step 1 Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.step1_logo}
            id="step1_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-2',
      title: {
        content: "Step 2 Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.step2_logo}
            id="step2_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-3',
      title: {
        content: "Step 3 Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.step3_logo}
            id="step3_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-4',
      title: {
        content: "Step 4 Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.step4_logo}
            id="step4_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    panels.push({
      key: 'panel-5',
      title: {
        content: "Step 5 Logo",
      },
      content: {
        content: (
          <UploadImageForm
            backgroundImage={settings.step5_logo}
            id="step5_logo"
            handleDrop={this.handleDrop}
            handleDelete={this.deleteElementLogo}
            accept="image/*"
          />
        )
      }
    });
    return (
      <Tab.Pane>
        <Accordion fluid styled panels={panels} />
      </Tab.Pane>
    )
  }

  renderSettingsTab = () => {
    const { settings } = this.state;
    return (
      <Tab.Pane>
        <Form>
          <Grid columns='equal'>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="web_countdown_enabled"
                    value={1}
                    checked={+settings.web_countdown_enabled === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Countdown Clock"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="web_show_cards_remaining_home_page"
                    value={1}
                    checked={+settings.web_show_cards_remaining_home_page === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Cards/Envelopes Remaining"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="display_largest_jackpot"
                    value={1}
                    checked={+settings.display_largest_jackpot === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Largest Jackpot"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Input
                    key="settings.hero_prize_text"
                    name="hero_prize_text"
                    defaultValue={settings.hero_prize_text}
                    fluid
                    label="Split The Pot Prize Text"
                    placeholder="Enter Prize Text..."
                    onChange={this.handleSettingsChange}
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Input
                    key="settings.hero_proceeds_text"
                    name="hero_proceeds_text"
                    defaultValue={settings.hero_proceeds_text}
                    fluid
                    label="Proceeds Text"
                    placeholder="Enter Proceeds Text..."
                    onChange={this.handleSettingsChange}
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="hero_box_highlighting"
                    value={1}
                    checked={+settings.hero_box_highlighting === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Hero Box Highlight"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="hero_logos_on_mobile"
                    value={1}
                    checked={+settings.hero_logos_on_mobile === 1}
                    onChange={this.handleSettingsChange}
                    label="Hide Primary Logos on Mobile"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Tab.Pane>
    )
  }

  renderSocialTab = () => {
    const { settings } = this.state;
    return (
      <Tab.Pane>
        <Form>
          <Grid columns='equal'>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="facebook"
                    value={1}
                    checked={+settings.facebook === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Facebook Social Share"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="twitter"
                    value={1}
                    checked={+settings.twitter === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Twitter Social Share"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="linkedIn"
                    value={1}
                    checked={+settings.linkedIn === 1}
                    onChange={this.handleSettingsChange}
                    label="Show LinkedIn Social Share"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="whatsApp"
                    value={1}
                    checked={+settings.whatsApp === 1}
                    onChange={this.handleSettingsChange}
                    label="Show WhatsApp Social Share"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="pinterest"
                    value={1}
                    checked={+settings.pinterest === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Pinterest Social Share"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="reddit"
                    value={1}
                    checked={+settings.reddit === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Reddit Social Share"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Radio toggle
                    name="socialEmail"
                    value={1}
                    checked={+settings.socialEmail === 1}
                    onChange={this.handleSettingsChange}
                    label="Show Email Social Share"
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column >
                <Segment>
                  <Form.Input
                    key="settings.socialTitle"
                    name="socialTitle"
                    defaultValue={settings.socialTitle}
                    fluid
                    label="Overide Default Social Title"
                    placeholder="Overide Default Social Title..."
                    onChange={this.handleSettingsChange}
                  />
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Tab.Pane>
    )
  }

  handleSettingsChange = (e, { name, value }) => {
    if (e) {
      e.preventDefault();
    }
    const { settings } = this.state;

    if (name === "web_countdown_enabled" && +settings.web_countdown_enabled === 1) {
      value = "0";
    }

    if (name === "web_show_cards_remaining_home_page" && +settings.web_show_cards_remaining_home_page === 1) {
      value = "0";
    }

    if (name === "display_largest_jackpot" && +settings.display_largest_jackpot === 1) {
      value = "0";
    }

    if (name === "hero_box_highlighting" && +settings.hero_box_highlighting === 1) {
      value = "0"
    }

    if (name === "hero_logos_on_mobile" && +settings.hero_logos_on_mobile === 1) {
      value = "0"
    }

    if (name === "facebook" && +settings.facebook === 1) {
      value = "0"
    }

    if (name === "twitter" && +settings.twitter === 1) {
      value = "0"
    }

    if (name === "linkedIn" && +settings.linkedIn === 1) {
      value = "0"
    }

    if (name === "whatsApp" && +settings.whatsApp === 1) {
      value = "0"
    }

    if (name === "pinterest" && +settings.pinterest === 1) {
      value = "0"
    }

    if (name === "reddit" && +settings.reddit === 1) {
      value = "0"
    }

    if (name === "socialEmail" && +settings.socialEmail === 1) {
      value = "0"
    }
    settings[name] = value;
    this.setState({
      settings: settings,
      needsSaving: true
    });
  };
  getUploadParams = ({ file, meta }) => {

    let formData = new FormData()
    formData.append('file', file)
    formData.append('location', file.location)
    const url = (apiUrl() + '/content/e-commerce');
    const headers = {
      "Authorization": "Bearer " + this.getCookie('accessToken'),
    }
    return {
      url: url,
      body: formData,
      headers: headers
    }
  }
  getCookie = name => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2)
      return parts
        .pop()
        .split(";")
        .shift();
  };
  closeModal = (status, error, fileWithMeta) => {
    if ((error && error !== "") || status === false) {
      this.setState({
        isSaving: false,
      });
      return;
    }
    const { settings } = this.state;
    fileWithMeta.forEach(file => {
      const response = JSON.parse(file.xhr.response)
      settings[response.location] = response.url;
    })
    this.setState(prevState => ({ settings }));
    this.finishSave();
  }
  render() {
    const {
      isLoading,
      xhrResponse,
      files,
      isSaving,
      colorPallete,
      settings,
      language,
      event,
      needsSaving,
      needsUploading,
    } = this.state;
    const panes = [];
    panes.push({
      menuItem: 'Theme',
      render: () => this.renderThemesTab()
    });
    panes.push({
      menuItem: 'Colors',
      render: () => this.renderColorsTab()
    });
    panes.push({
      menuItem: 'Assets',
      render: () => this.renderAssetsTab()
    });
    panes.push({
      menuItem: 'Steps',
      render: () => this.renderStepsTab()
    });
    panes.push({
      menuItem: 'Settings',
      render: () => this.renderSettingsTab()
    });
    panes.push({
      menuItem: 'Social',
      render: () => this.renderSocialTab()
    });

    return (
      <Segment basic loading={isLoading}>
        <ModalUpload
          getUploadParams={this.getUploadParams}
          files={files}
          openModal={isSaving && needsUploading}
          closeModal={this.closeModal}
        />
        <Message
          hidden={xhrResponse.success === null}
          content={xhrResponse.message}
          success={xhrResponse.success === true}
          error={!xhrResponse.success && xhrResponse.success !== null}
        />
        {!isLoading &&
          <Grid>
            <Grid.Column width={10}>
              <div
                style={{
                  display: "block",
                  transform: "scale(1.0, 0.7)",
                  transformOrigin: "top left"
                }}
              >
                <Segment inverted>
                  <Container
                    style={{
                      position: "relative",
                      height: "auto",
                      backgroundColor: "white",
                      border: "1px solid white"
                    }}
                  >
                    <WebSalesTemplate
                      isLoading={isLoading}
                      settings={settings}
                      language={language}
                      colorPallete={colorPallete}
                      event={event}
                    />
                  </Container>
                </Segment>
              </div>
            </Grid.Column>
            <Grid.Column width={6}>
              {needsSaving && <Button
                icon="save"
                content="Save"
                primary
                floated="right"
                onClick={this.handleSave}
              />}
              <br /><br />
              <Tab menu={{ attached: 'top' }} panes={panes} />
            </Grid.Column>
        </Grid>
        }
      </Segment>
    );
  }
}

WebSales.contextType = AppContext;
export default WebSales;
